import { ref } from "config/constants";
import { showMessage } from "data/messages/actions";
import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATION,
  FETCH_NOTIFICATION_SUCCESS,
  READ_NOTIFICATION,
  READ_NOTIFICATION_SUCCESS,
  UNREAD_NOTIFICATION,
  UNREAD_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS
} from "./types";

const Notifications = ref.child("messages");

export function fetchNotifications(accountid) {
  return dispatch => {
    dispatch({
      type: FETCH_NOTIFICATIONS,
      payload: { pending: true }
    });
    Notifications.child(accountid).on("value", snapshot => {
      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: snapshot.val()
      });
    });
  };
}

export function fetchNotification(accountid, notificationid) {
  return dispatch => {
    dispatch({
      type: FETCH_NOTIFICATION,
      payload: { pending: true }
    });
    Notifications.child(accountid)
      .child(notificationid)
      .on("value", snapshot => {
        dispatch({
          type: FETCH_NOTIFICATION_SUCCESS,
          payload: snapshot.val()
        });
      });
  };
}

export function readNotification(accountid, notificationid) {
  return dispatch => {
    dispatch({
      type: READ_NOTIFICATION,
      payload: { pending: true }
    });
    Notifications.child(accountid)
      .child(notificationid)
      .update({ read: true }, snapshot => {
        dispatch({
          type: READ_NOTIFICATION_SUCCESS
        });
      });
  };
}

export function unreadNotification(accountid, notificationid) {
  return dispatch => {
    dispatch({
      type: UNREAD_NOTIFICATION,
      payload: { pending: true }
    });
    Notifications.child(accountid)
      .child(notificationid)
      .update({ read: false }, snapshot => {
        dispatch({
          type: UNREAD_NOTIFICATION_SUCCESS
        });
      });
  };
}

export function deleteNotification(accountid, notificationid) {
  return dispatch => {
    dispatch({
      type: DELETE_NOTIFICATION,
      payload: { pending: true }
    });
    Notifications.child(accountid)
      .child(notificationid)
      .update({ deleted: true }, snapshot => {
        dispatch({
          type: DELETE_NOTIFICATION_SUCCESS
        });
        dispatch(showMessage(`Neddelandet har raderats.`));
      })
      .catch(error => {
        dispatch(showMessage(error.message));
      });
  };
}



// WEBPACK FOOTER //
// ./src/data/notifications/actions.js